import React, { useState } from "react";
import { subscribeNewsletter } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function NewsletterSection() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await subscribeNewsletter(email);
      setMsg(res.message || "Merci !");
      setEmail("");
    } catch (err) {
      setMsg("Une erreur est survenue. Réessayez.");
    }
    setTimeout(() => setMsg(""), 4000);
  };

  return (
    <section className="newsletter reveal" aria-label="Newsletter" data-testid="newsletter-section">
      <p className="section-tag" style={{ color: "var(--gold-l)" }}>{t("nl.tag")}</p>
      <h2>{t("nl.title1")}<br /><em>{t("nl.title2")}</em></h2>
      <p>{t("nl.desc")}</p>
      <form className="newsletter-form" onSubmit={onSubmit} aria-label="Formulaire newsletter">
        <input
          type="email"
          placeholder={t("nl.placeholder")}
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-label="Email"
          data-testid="newsletter-email"
        />
        <button type="submit" data-testid="newsletter-submit">{t("nl.button")}</button>
      </form>
      {msg ? (
        <p style={{ marginTop: "1rem", color: "var(--gold-l)" }} data-testid="newsletter-msg">{msg}</p>
      ) : null}
    </section>
  );
}
